import { motion } from "framer-motion";
import { PawPrint } from "./Doodles";

const GROUP_PHOTO =
  "https://customer-assets-eiarnc6j.emergentagent.net/job_e677a045-c491-4d1e-9d9e-6c4f19bb9db5/artifacts/a4twtoby_Screenshot%202026-08-30%20001746.png";

const VolunteersBanner = ({ onNavigate }) => {
  return (
    <section
      data-testid="volunteers-banner"
      className="relative overflow-hidden border-b-2 border-[#16294B]"
      aria-label="Our volunteers make it happen"
    >
      <div>
        <img
          src={GROUP_PHOTO}
          alt="Project Archie volunteers standing together behind the doghouses they built"
          loading="lazy"
          className="block h-auto w-full"
        />
      </div>
      <div className="absolute inset-0 bg-[#16294B]/65" aria-hidden="true" />

      <motion.span
        initial={{ opacity: 0, scale: 0.5 }}
        whileInView={{ opacity: 1, scale: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6, delay: 0.4 }}
        className="absolute left-8 top-8 md:left-16 md:top-14"
        aria-hidden="true"
      >
        <PawPrint className="h-8 w-8 md:h-10 md:w-10" color="#FBF3E3" />
      </motion.span>
      <motion.span
        initial={{ opacity: 0, scale: 0.5 }}
        whileInView={{ opacity: 1, scale: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6, delay: 0.6 }}
        className="absolute bottom-8 right-8 md:bottom-14 md:right-16"
        aria-hidden="true"
      >
        <PawPrint className="h-8 w-8 md:h-10 md:w-10" color="#FBF3E3" />
      </motion.span>

      <div className="absolute inset-0 z-10 mx-auto flex max-w-4xl flex-col items-center justify-center px-5 py-16 text-center sm:px-8">
        <motion.h2
          data-testid="volunteers-banner-heading"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          className="font-display text-5xl leading-tight text-[#FBF3E3] md:text-7xl"
        >
          Our Volunteers Make It Happen
        </motion.h2>
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, delay: 0.2 }}
          className="mt-5 max-w-xl text-base font-medium leading-relaxed text-[#FBF3E3]/90 md:text-lg"
        >
          Project Archie volunteers show up with tools in hand and compassion in heart.
          This is what community looks like.
        </motion.p>
        <motion.button
          data-testid="volunteers-banner-join-btn"
          onClick={() => onNavigate("#join")}
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, delay: 0.35 }}
          className="btn-press mt-9 rounded-full border-2 border-[#FBF3E3] bg-transparent px-8 py-3.5 text-sm font-bold uppercase tracking-widest text-[#FBF3E3] shadow-[5px_5px_0_0_#FBF3E3] hover:bg-[#E63946] hover:border-[#E63946]"
        >
          Join Our Team
        </motion.button>
      </div>
    </section>
  );
};

export default VolunteersBanner;
